/* eslint-disable consistent-return */
import React from 'react'
import PropTypes from 'prop-types'
import {
  Image, Text, TouchableHighlight, View,
} from 'react-native'
import panelStyles from '../../styles/panel'

const showText = (buttonText) => {
  if (buttonText) { return (<Text ellipsizeMode="tail" numberOfLines={2} style={panelStyles.panelText}>{buttonText}</Text>) }
}

function LightButton({
  accessibilityLabel, testID, imageSource, onPressHandler, buttonText, imageStyle,
}) {
  return (
    <TouchableHighlight
      style={[panelStyles.elevatedContainer, panelStyles.lightButton, panelStyles.cardShadow, panelStyles.cardRounding]}
      onPress={onPressHandler}
      testID={testID}
      underlayColor="#ddd"
    >
      <View style={{ alignItems: 'center' }}>
        <Image testID={`image-${testID}`} accessibilityLabel={accessibilityLabel} style={[panelStyles.lightImage, imageStyle]} source={imageSource} />
        {showText(buttonText)}
      </View>
    </TouchableHighlight>
  )
}

LightButton.defaultProps = {
  buttonText: null,
  imageStyle: { width: 77, height: 77, resizeMode: 'contain' },
}

LightButton.propTypes = {
  accessibilityLabel: PropTypes.string.isRequired,
  testID: PropTypes.string.isRequired,
  imageSource: PropTypes.number.isRequired,
  onPressHandler: PropTypes.func.isRequired,
  buttonText: PropTypes.string,
  imageStyle: PropTypes.instanceOf(Object),
}

export default LightButton
